import { DateTime } from 'luxon';
import { ParkerRegistrationOffense, ParkingProcessTariffInfoDTO } from 'src/app/base/models/models.swagger.generated';
import { ParkingTimeGrid } from './from-backend/parking-time-grid';
import { SessionTimeSlicer } from './from-backend/session-time-slicer';

export interface ParkingTimesState {
  isParkingPossible: boolean;
  maxParkingDuration: number;
  isParkingUnlimited: boolean;
  maxEndTime: DateTime | null;
  hasTariffs: boolean;
}

export class ParkingTimesHelper {
  public static calculateParkingTimesState(startTimeUtc: DateTime,
                                           tariffs: ParkingProcessTariffInfoDTO[] | null | undefined,
                                           tariffsMaxValidityTime: DateTime | null | undefined,
                                           subscriptionsMaxParkingDuration: number,
                                           fallbackParkingTariffs: ParkingProcessTariffInfoDTO[] | null | undefined,
                                           previousState: Pick<ParkingTimesState, 'maxEndTime' | 'hasTariffs'>): ParkingTimesState {
    const state: ParkingTimesState = {
      isParkingPossible: false,
      maxParkingDuration: subscriptionsMaxParkingDuration,
      isParkingUnlimited: false,
      maxEndTime: previousState.maxEndTime,
      hasTariffs: previousState.hasTariffs,
    };

    if (state.maxParkingDuration < 0) {
      return state;
    }

    if (!tariffs) {
      state.hasTariffs = false;
      return state;
    }

    const timeGrid = new ParkingTimeGrid(
      startTimeUtc,
      subscriptionsMaxParkingDuration
        ? startTimeUtc.plus({ minutes: subscriptionsMaxParkingDuration })
        : startTimeUtc.plus({ days: 8 })
    );

    timeGrid.setup(tariffs, tariffsMaxValidityTime?.toUTC(), fallbackParkingTariffs);
    const slicer = SessionTimeSlicer.for(timeGrid);
    const slices = slicer.sliceOverWholeGridSpan();

    if (slices?.length > 0 && slices[0].offense === ParkerRegistrationOffense.NoOffense) {
      state.isParkingPossible = true;

      if (slices[slices.length - 1].offense === ParkerRegistrationOffense.NoOffense) {
        if (state.maxParkingDuration) {
          state.maxEndTime = slices[slices.length - 1].timeRange.endTime;
        } else {
          state.maxEndTime = null;
          state.isParkingUnlimited = true;
        }
      } else {
        state.maxEndTime = slices[slices.length - 2].timeRange.endTime.set({ second: 0, millisecond: 0 });
        state.maxParkingDuration = state.maxEndTime.diff(
          slices[0].timeRange.startTime.set({ second: 0, millisecond: 0 }),
          'minutes'
        ).minutes;
      }
    }

    state.hasTariffs = true;
    return state;
  }
}